<template>
    <reveal-view>
        <h2 slot="header" class="title">Reģistrējies</h2>

        <div class="content">
            <div class="row social-buttons">
                <button type="button" class="button mykoob large expanded" @click="getRedirect('mykoob')">MyKoob</button>
                <button type="button" class="button eklase large expanded" @click="getRedirect('eklase')">E-klase</button>
            </div>

            <div class="or fancy"><span></span><span>vai</span><span></span></div>

            <div class="text-center">
                <button class="button clear" type="button" @click="goToRegister()">Pieprasi reģistrāciju ar e-pastu.</button>
            </div>

            <hr/>

            <div class="links">
                <a href="#" @click.prevent v-open-in-reveal="loginReveal">Jau ir savs konts? Pieraksties šeit.</a>
            </div>
        </div>

    </reveal-view>
</template>

<script>
    import RevealView from '../common/RevealView'
    import OpenInReveal from '../../directives/OpenInReveal'
    import auth from '../../api/auth'

    export default  {

        beforeCreate () {

        },

        data() {
            return {
                loginReveal: require('./LoginReveal.vue')
            }
        },

        methods: {
            goToRegister() {
                this.$modal.closeReveal()
                    .then(() => this.$router.push({ name: 'auth.register' }));
            },

            getRedirect(provider) {
                console.log('getting redirect for', provider);
                auth.redirect(provider)
            }
        },

        components: { RevealView },

        directives: { OpenInReveal }
    }
</script>

<style lang="scss" scoped>
    @import "../../../sass/settings";
    @import "../../../sass/mixins";
    @import "../../../sass/foundation/config";

    .note {
        font-size: px-em(11px);

        label {
            font-size: inherit;
        }
    }

    .links {
        font-size: px-em(14px);
        text-align: center;
    }

    .content {
        max-width: px-em(360px);
        margin: 0 auto;
    }

    .social-buttons {
        flex-wrap: nowrap;
        > *:not(:last-child) {
            margin-right: 1rem;
        }
    }

    .or.fancy {
        margin-bottom: 1rem;
        color: $color-light-gray;

        > span:first-child,
        > span:last-child {
            border-top-color: $color-light-gray;
        }
    }
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/auth/RegisterReveal.vue